import { orientation_based_attr } from './ori_att'

export const ori_bas_attr_fil = (option) => {
    var returnSomthing = '';
    orientation_based_attr().orientaions.sort((a,b) => {
        return a.orientation__orientation_order - b.orientation__orientation_order
    }).map(val => {
        val.attributes.map(val1 => {
            if(val1.attribute__attribute_name.toLowerCase() == option.toLowerCase()) {
                returnSomthing = val.orientation__orientation_name
            }
        })
    })
    return returnSomthing
}


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/orientation_based_attribute_filter.js